import { pagenation } from './pagenation';

export function caselist() {
  const caseArea = document.querySelector('#case');
  const caseCont = document.querySelector('#caseCont');
  const caseList = document.querySelector('#caseList');
  const caseLoading = document.querySelector('#caseLoading');
  const header = document.querySelector('#header');
  const apiUrl = 'https://secure02.red.shared-server.net/www.o-tec.co.jp/cron_marge/case.php';
  const errorArea = document.querySelector('#caseError');

  //paramsに値が存在する場合、一覧までページスクロールする
  const pageScrollView = (params) => {
    if(params.size > 0) {
      const caseList_rect = caseList.getBoundingClientRect();
      const caseList_top = caseList_rect.top;
      const header_height = header.offsetHeight;
      //ヘッダーと要素の余白
      const margin_top = 50;
      const target_top = caseList_top - header_height - margin_top;
      window.scrollTo({
        top: target_top
      });
    }
  }

  const postCard = (obj) => {
    let url = obj.url;
    let thumbnail = obj.thumbnail;
    let title = obj.title;
    let area = obj.area;
    let usage = obj.usage_label;
    let completion = obj.completion;
    let text = obj.text;
    let element = document.createElement('a');
    element.classList.add('c-layoutType09_item', 'c-caseType01', 'c-caseType02');
    element.setAttribute('href', url);

    element.innerHTML = `<div class="c-caseType01_pic c-frame_radius">
      <img src="${thumbnail}" alt="${title}">
    </div>
    <p class="c-caseType01_ttl u-color_txt--main u-txt_weight--bold u-mt--24">${title}</p>
    <div class="c-caseType01_tag u-mt--10">
    <span class="c-tagType01--wide">${area}</span>
    </div>
    <div class="c-caseType01_info u-flex u-flex_column u-mt--10">
      <dl class="u-flex u-flex_gap--10">
        <dt>
          <span class="c-tagType02">用 途</span>
        </dt>
        <dd class="c-caseType01_txt">${usage}</dd>
      </dl>
      <dl class="u-flex u-flex_gap--10">
        <dt>
          <span class="c-tagType02">竣 工</span>
        </dt>
        <dd class="c-caseType01_txt">${completion}</dd>
      </dl>
    </div>
    <p class="c-caseType01_txt u-mt--10">${text}</p>`
    return element;
  }

  //取得したデータを一覧に出力する
  const listOutput = (array) => {
    const posts = array;
    posts.forEach(post => {
      let element = postCard(post);
      caseList.appendChild(element);
    });
  }

  const errorOutput = () => {
    errorArea.classList.add('is-view');
  }

  //case.phpに連携して、投稿データを取得する
  const getCaseData = (params) => {
    const params_data = {
      usage: params.has('usage') ? params.getAll('usage') : ['すべて'],
      area: params.has('area') ? params.getAll('area') : ['すべて'],
      page: params.has('page') ? params.get('page') : 1
    }

    fetch(apiUrl, {
      method : "POST",
      headers: {
        'Content-Type': 'application/json' // JSON形式のデータのヘッダー
      },
      body: JSON.stringify(params_data)
    })
    .then((response) => {
      return response.json()　//ここでBodyからJSONを返す
    })
    .then((result) => {
      if(result.res) {
        listOutput(result.data);
        pagenation(result.max_page);
      } else {
        errorOutput();
      }
    })
    .then(() => {
      caseLoading.classList.add('is-hidden');
    })
    .catch((e) => {
      console.log(e)  //エラーをキャッチし表示     
    })
  }

  if(caseArea) { //「#case」要素が存在する場合
    // URLを取得
    let localUrl = new URL(window.location.href);
    // URLSearchParamsオブジェクトを取得
    let params = localUrl.searchParams;

    pageScrollView(params);
    getCaseData(params);
  }
}